/**
 * 크롤러(AdsBot-Google·Googlebot·bingbot·Yeti·HeadlessChrome 등) 판별.
 * UA 미확인 시에는 false를 반환한다.
 */
const BOT_USER_AGENT_REGEX =
  /bot|crawl|spider|adsbot|googlebot|bingbot|yeti|headlesschrome|lighthouse|slurp/i

export const isBotUserAgent = (
  userAgent: string | undefined = typeof navigator === 'undefined'
    ? undefined
    : navigator.userAgent
): boolean => Boolean(userAgent) && BOT_USER_AGENT_REGEX.test(userAgent!)
